<template>
  <div class="ur-login">
    <!-- ── Main body ── -->
    <div class="ur-login-body">
      <div class="ur-login-grid">

        <!-- Left panel: logo + welcome -->
        <div class="ur-login-left">
          <img :src="logoUrl" class="ur-login-logo-img" alt="logo" />
          <div class="ur-login-welcome">{{ $t('URBANRENEWAL_SELECT.LOGIN.WELCOME') }}</div>
          <!-- 副標題：依需求暫時隱藏，保留備用 -->
          <!-- <div class="ur-sel-login-desc">{{ $t('URBANRENEWAL_SELECT.LOGIN.SYS_DESC') }}</div> -->
        </div>

        <!-- Right panel: forgot password card -->
        <div class="ur-login-card">
          <h2 class="ur-login-card-title">{{ $t('URBANRENEWAL_SELECT.FORGOT.TITLE') }}</h2>

          <template v-if="!doneMsg">
            <p class="ur-login-card-desc">{{ $t('URBANRENEWAL_SELECT.FORGOT.DESC') }}</p>

            <!-- Error message -->
            <div v-if="errorMsg" class="ur-login-error">{{ errorMsg }}</div>

            <!-- Account field -->
            <div class="ur-login-field">
              <label class="ur-login-field-label">{{ $t('URBANRENEWAL_SELECT.FORGOT.ACCOUNT') }}</label>
              <div class="ur-login-field-row">
                <span class="ur-login-field-icon">
                  <!-- Person icon -->
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="8" r="4"/>
                    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
                  </svg>
                </span>
                <input
                  class="ur-login-field-input"
                  type="text"
                  v-model="username"
                  autocomplete="username"
                  @keyup.enter="submit"
                  @input="errorMsg = ''"
                />
              </div>
            </div>

            <!-- Submit button -->
            <button
              class="ur-login-submit-btn"
              type="button"
              :disabled="submitting"
              @click="submit"
            >
              {{ $t('URBANRENEWAL_SELECT.FORGOT.SUBMIT') }}
            </button>
          </template>

          <template v-else>
            <div class="ur-sel-success">{{ doneMsg }}</div>
          </template>

          <!-- Back to login -->
          <div class="ur-login-forgot-wrap">
            <button class="ur-login-forgot-link" type="button" @click.prevent="goLogin">
              {{ $t('URBANRENEWAL_SELECT.FORGOT.BACK_LOGIN') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Footer ── -->
    <footer class="ur-login-footer">
      {{ $t('URBANRENEWAL_SELECT.LOGIN.COPYRIGHT') }}
      <span class="ur-login-footer-sep">|</span>
      <a class="ur-login-footer-link" href="/docs/DPF.pdf" target="_blank" rel="noopener">Data Processing Agreement</a>
    </footer>
  </div>
</template>

<script>
import UrbanRenewalSelectService from '@/services/UrbanRenewalSelectService';
import LoginValidationService from '@/services/LoginValidationService';

export default {
  name: 'UrbanRenewalSelectForgotPassword',

  data() {
    return {
      username: '',
      submitting: false,
      doneMsg: '',
      errorMsg: '',
      logoUrl: require('@/assets/images/UPGPT.png'),
    };
  },

  mounted() {
    if (this.tenant) {
      LoginValidationService.getUrbanRenewalLogo(this.tenant)
        .then(res => {
          if (res.data && res.data.logo_url) {
            this.logoUrl = res.data.logo_url;
          }
        })
        .catch(() => {});
    }
  },

  computed: {
    tenant() {
      return this.$route.query.tenant || window.localStorage.getItem('tenant') || '';
    },
  },

  methods: {
    async submit() {
      if (!this.username.trim()) {
        this.errorMsg = this.$t('URBANRENEWAL_SELECT.FORGOT.ERR_REQUIRED');
        return;
      }
      this.submitting = true;
      this.errorMsg = '';
      try {
        await UrbanRenewalSelectService.forgotPassword(this.username.trim());
        this.doneMsg = this.$t('URBANRENEWAL_SELECT.FORGOT.DONE');
      } catch (e) {
        // 枚舉防護：無論帳號是否存在或呼叫是否失敗，一律顯示相同成功訊息
        this.doneMsg = this.$t('URBANRENEWAL_SELECT.FORGOT.DONE');
      } finally {
        this.submitting = false;
      }
    },

    goLogin() {
      this.$router.push({
        path: '/urbanrenewal/select/login',
        query: this.tenant ? { tenant: this.tenant } : {},
      });
    },
  },
};
</script>
